import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Instagram, Mail, Music2 } from "lucide-react";
import { LogoMark } from "./Logo";
import { WaitlistForm } from "./WaitlistForm";

export const Footer = () => (
  <footer data-testid="footer" id="unisciti" className="relative bg-[#1A1A1A] text-[#F9F8F6] overflow-hidden">
    <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[50rem] h-[30rem] rounded-full bg-[#FF6B35]/15 blur-3xl pointer-events-none" />
    <div className="relative px-6 sm:px-10 lg:px-16 py-28 lg:py-36 flex flex-col items-center text-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.8, rotate: -8 }}
        whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      >
        <LogoMark className="w-16 h-16" />
      </motion.div>

      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        data-testid="footer-title"
        className="font-display font-extrabold mt-10 text-4xl sm:text-6xl lg:text-8xl tracking-tight leading-[0.95] max-w-5xl"
      >
        Unisciti a <span className="text-[#FF6B35]">FuffyFam</span>
      </motion.h2>

      <motion.p
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.9, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
        className="mt-6 text-base sm:text-lg text-[#F9F8F6]/60 max-w-xl leading-relaxed"
      >
        Il lancio è vicino. Lascia la tua email e apriremo le porte prima a te e al tuo cane.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.9, delay: 0.25, ease: [0.16, 1, 0.3, 1] }}
        className="mt-10 w-full max-w-xl flex justify-center [&_form]:bg-[#F9F8F6] [&_form]:border-0 [&_form]:ring-offset-[#1A1A1A]"
      >
        <WaitlistForm idPrefix="footer-waitlist" />
      </motion.div>
    </div>

    <div className="relative border-t border-[#F9F8F6]/10 px-6 sm:px-10 lg:px-16 py-8 flex flex-col sm:flex-row items-center justify-between gap-6">
      <p className="text-xs sm:text-sm text-[#F9F8F6]/50 font-medium">
        © 2026 FuffyFam · fuffyfam.com
      </p>
      <div className="flex items-center gap-3">
        {[
          { icon: Instagram, label: "Instagram", testId: "footer-social-instagram", href: "https://instagram.com" },
          { icon: Music2, label: "TikTok", testId: "footer-social-tiktok", href: "https://tiktok.com" },
          { icon: Mail, label: "Email", testId: "footer-social-email", href: "mailto:supporto.fuffyfam@gmail.com" },
        ].map(({ icon: Icon, label, testId, href }) => (
          <motion.a
            key={label}
            href={href}
            target={href.startsWith("http") ? "_blank" : undefined}
            rel="noopener noreferrer"
            aria-label={label}
            data-testid={testId}
            whileHover={{ scale: 1.1, y: -2 }}
            whileTap={{ scale: 0.95 }}
            className="flex items-center justify-center w-10 h-10 rounded-full border border-[#F9F8F6]/15 text-[#F9F8F6]/70 hover:text-[#1A1A1A] hover:bg-[#FF6B35] hover:border-[#FF6B35] transition-colors duration-300"
          >
            <Icon className="w-4 h-4" />
          </motion.a>
        ))}
      </div>
      <div className="flex items-center gap-5">
        <p className="text-xs sm:text-sm text-[#F9F8F6]/50">Fatta con amore, per i cani d'Italia.</p>
        <Link
          to="/privacy"
          data-testid="footer-privacy-link"
          className="text-xs sm:text-sm font-semibold text-[#F9F8F6]/70 hover:text-[#FF6B35] transition-colors duration-300"
        >
          Privacy Policy
        </Link>
        <Link
          to="/terms"
          data-testid="footer-terms-link"
          className="text-xs sm:text-sm font-semibold text-[#F9F8F6]/70 hover:text-[#FF6B35] transition-colors duration-300"
        >
          Termini di Servizio
        </Link>
      </div>
    </div>
  </footer>
);
